export default "__VITE_ASSET__zyMVWLVt__"